module.exports = __webpack_public_path__ + "img/retention.5dc0faea.jpg";